import React, { FC } from 'react';

import AppRouter from '../routers/AppRouter';

const App: FC = () => {
  return <AppRouter />;
};

export default App;
